import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  position: absolute;
  z-index: 5;
  top: 52px;
  right: 15px;
`;

export const Wrapper = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    min-width: 240px;
    max-width: calc(100% - 30px);
    padding: 4px;
    overflow: hidden;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_2};
  `}
`;

export const SubMenu = styled.li`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 44px;
    padding: 0 8px;
    transition: background 0.1s ease-in-out;
    background: transparent;
    cursor: pointer;
    gap: 8px;

    &:hover,
    &:active {
      background: ${theme.backgroundColor.bg_dark_3};
    }

    span {
      color: ${theme.content.content_light_1};
      ${theme.fontStyle.text.body16_medium};
    }

    &.red {
      span {
        color: ${theme.themeColor.negative};
      }
    }
  `}
`;

export const ToggleButtonBox = styled.div`
  ${({ theme }) => css``}
`;

export const Input = styled.input`
  ${({ theme }) => css`
    ${theme.a11y.hidden}

    &:checked ~ .toggleButton {
      background: ${theme.themeColor.main_2};

      .toggle {
        left: calc(100% - 27px);
        background: #fff;
      }
    }
  `}
`;

export const ToggleButton = styled.label`
  ${({ theme }) => css`
    display: block;
    position: relative;
    width: 46px;
    height: 28px;
    transition: all 0.2s ease-in;
    border-radius: 40px;
    background-color: ${theme.backgroundColor.disabled};
    cursor: pointer;
  `}
`;

export const Toggle = styled.span`
  ${({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 4px;
    width: 23px;
    height: 23px;
    transform: translateY(-50%);
    transition: all 0.2s ease-in;
    border-radius: 50%;
    background: ${theme.always.basic};
  `}
`;
